"use client";

import { LocaleLink as Link } from "@/components/shared/LocaleLink";
import { useLanguage } from "@/contexts/LanguageContext";

export function NotFoundView() {
  const { t, isRtl } = useLanguage();

  return (
    <section className="flex min-h-[calc(100vh-8rem)] flex-col items-center justify-center bg-[#F4F4F4] px-5 py-16 sm:py-24">
      <div
        className={`mx-auto w-full max-w-xl text-center ${isRtl ? "font-[family-name:var(--font-cairo)]" : ""}`}
      >
        <p
          className="select-none text-[clamp(5rem,18vw,9rem)] font-bold leading-none tracking-tight text-[#BD2226]/15"
          aria-hidden
        >
          {t("notFound.code")}
        </p>
        <h1 className="-mt-[0.35em] text-2xl font-bold text-[#130F0E] sm:text-3xl">
          {t("notFound.title")}
        </h1>
        <p className="mt-4 text-base text-[#6B7280] sm:text-lg">
          {t("notFound.description")}
        </p>
        <div className="mt-10 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
        <Link
            href="/find-workshop"
            className="inline-flex items-center justify-center rounded-lg border border-[#E5E5E5] bg-white px-6 py-3 text-sm font-semibold text-[#BD2226] transition-colors hover:border-[#BD2226]/30 hover:bg-[#FFF5F5]"
          >
            {t("notFound.findWorkshop")}
          </Link>
          <Link
            href="/"
            className="inline-flex items-center justify-center rounded-lg bg-[#BD2226] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#C00322]"
          >
            {t("notFound.backHome")}
          </Link>
         
          <Link
            href="/contact"
            className="inline-flex items-center justify-center rounded-lg border border-[#E5E5E5] bg-white px-6 py-3 text-sm font-semibold text-[#BD2226] transition-colors hover:border-[#BD2226]/30 hover:bg-[#FFF5F5]"
          >
            {t("notFound.contactUs")}
          </Link>
        </div>
      </div>
    </section>
  );
}
